module.exports = __webpack_public_path__ + "static/media/grouptins.5f444bcb.jpeg";